import { makeStyles } from '@material-ui/core';
import { Theme } from '@styles/theme/theme'
import React from 'react';

export interface SvgInfoIconProps {
  width?: string;
  height?: string;
  color?: string;
  hoverColor?: string;
}
interface StyleProps {
  hoverColor?: string;
}
export const useStyles = makeStyles<Theme, StyleProps>(() => ({
  icon: {
    cursor: 'pointer',
    '&:hover path': {
      stroke: (props) => props.hoverColor,
    },
  },
}));

export const SvgInfoIcon = ({
  width = '32',
  height = '32',
  color = '#000',
  hoverColor = '#000',
}: SvgInfoIconProps) => {
  const classes = useStyles({ hoverColor });
  return (
    <svg
      className={classes.icon}
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 19V16M16 13.025V13M24 16C24 20.4183 20.4183 24 16 24C11.5817 24 8 20.4183 8 16C8 11.5817 11.5817 8 16 8C20.4183 8 24 11.5817 24 16Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};
